import MultiSelectInput from './MultiSelectInput';
export default MultiSelectInput;